import { render, staticRenderFns } from "./VueInputGroup.vue?vue&type=template&id=6989aad9&"
import script from "./VueInputGroup.vue?vue&type=script&lang=js&"
export * from "./VueInputGroup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports